import { render } from "./Facilitatorboard_2.vue?vue&type=template&id=6637ee6e"
import script from "./Facilitatorboard_2.vue?vue&type=script&lang=js"
export * from "./Facilitatorboard_2.vue?vue&type=script&lang=js"

import "./Facilitatorboard_2.vue?vue&type=style&index=0&id=6637ee6e&lang=scss"
script.render = render

export default script